function formatAddress(address) {
	// Usa una regex per separare le diverse parti della stringa
	const addressPattern = /(.*? - )(.*?)(, piano )(\d+)/;
	const match = address.match(addressPattern);

	if (!match) return address; // Se non corrisponde, ritorna l'originale

	// Estrai le parti desiderate
	const street = match[1].trim().slice(0, -2); // Rimuovi " - " dalla fine
	const cityZip = match[2].trim();
	const floor = `Piano ${match[4].trim()}`;

	// Costruisci la stringa formattata con `<br>` per i nuovi paragrafi
	return `${street}<br>${cityZip}<br>${floor}`;
}

function initMap() {
	const mapElements = document.querySelectorAll(".gmap");

	if (!mapElements.length) return;

	mapElements.forEach(function (mapElement) {
		const lat = parseFloat(mapElement.getAttribute("data-map-lat"));
		const lng = parseFloat(mapElement.getAttribute("data-map-lng"));
		const address = mapElement.getAttribute("data-map-address");
		const companyName = mapElement.getAttribute("data-map-company");

		// Coordinate corrette per Via Partigiani 5, Bergamo
		const location = {
			lat: lat,
			lng: lng,
		};

		// Stili personalizzati per la mappa
		const customMapStyle = [
			{ featureType: "administrative", elementType: "all", stylers: [{ saturation: "-100" }] },
			{ featureType: "administrative.province", elementType: "all", stylers: [{ visibility: "off" }] },
			{ featureType: "administrative.locality", elementType: "labels.text", stylers: [{ color: "#c9b991" }, { weight: "0.5" }] },
			{ featureType: "landscape", elementType: "all", stylers: [{ saturation: -100 }, { lightness: 65 }, { visibility: "on" }] },
			{ featureType: "landscape.man_made", elementType: "geometry.stroke", stylers: [{ color: "#dfd2b3" }] },
			{ featureType: "poi", elementType: "all", stylers: [{ visibility: "off" }] },
			{ featureType: "poi.park", elementType: "geometry.fill", stylers: [{ visibility: "on" }, { color: "#e8e3d4" }] },
			{ featureType: "road", elementType: "all", stylers: [{ saturation: "-100" }] },
			{ featureType: "road.highway", elementType: "all", stylers: [{ visibility: "simplified" }] },
			{ featureType: "road.arterial", elementType: "all", stylers: [{ lightness: "30" }] },
			{ featureType: "road.local", elementType: "all", stylers: [{ lightness: "40" }] },
			{ featureType: "transit", elementType: "all", stylers: [{ saturation: -100 }, { visibility: "simplified" }] },
			{ featureType: "water", elementType: "geometry", stylers: [{ hue: "#DAE0E3" }, { lightness: -25 }, { saturation: -97 }] },
			{ featureType: "water", elementType: "labels", stylers: [{ lightness: -25 }, { saturation: -100 }, { color: "#bfb28f" }, { weight: "0.25" }] },
		];

		// Opzioni per la mappa
		const mapOptions = {
			zoom: 17,
			center: location,
			styles: customMapStyle,
			mapTypeControl: false,
			zoomControl: true,
			zoomControlOptions: {
				position: google.maps.ControlPosition.RIGHT_CENTER,
			},
			scaleControl: true,
			streetViewControl: false,
			fullscreenControl: false,
		};

		// Creazione della mappa
		const map = new google.maps.Map(mapElement, mapOptions);

		// Configurazione del marker personalizzato
		const customMarker = {
			url: ajax_object.template_url + "/assets/img/marker.png",
			size: new google.maps.Size(56, 56),
			anchor: new google.maps.Point(28, 56),
			scaledSize: new google.maps.Size(56, 56),
		};

		// Creazione del marker
		const marker = new google.maps.Marker({
			position: location,
			map: map,
			icon: customMarker,
			title: "Via Partigiani n. 5 - Piano 4",
			animation: google.maps.Animation.DROP,
		});

		// Aggiunta di un InfoWindow per mostrare l'indirizzo completo
		const infoWindow = new google.maps.InfoWindow({
			content: `
	            <div style="padding: 10px;">
	                <strong class="h5 serif fw-700 d-block mb-1 pt-2 text-primary">${companyName}</strong>
	                <p style="margin: 0;">${formatAddress(address)}</p>
	            </div>`,
		});

		infoWindow.open(map, marker);

		// Apertura dell'InfoWindow al click sul marker
		marker.addListener("click", () => {
			infoWindow.open(map, marker);
		});
	});
}
